function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import VerticalTimerTabs from "segments/desktop/core-components/vertical-timer-tabs/vertical-timer-tabs";
import { XS } from "constants/sizes";
import Testimonial from "segments/desktop/core-components/testimonial/testimonial";
import FullWithBulletsParagraphComponent from "segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-component";
import { StyledSideBySideTabsAndTestimonialTabsComponent } from "./side-by-side-tabs-and-testimonial-tabs-component.scss";
import DefaultProps, { TAB_CONTENT_DEFAULT_PROPS } from "./default-props";
const SideBySideTabsAndTestimonialTabsComponent = (_param)=>{
    var { tabContent, title, advancedTitleConfig, prerenderTabs } = _param, rest = _object_without_properties(_param, [
        "tabContent",
        "title",
        "advancedTitleConfig",
        "prerenderTabs"
    ]);
    const contentRenderer = (contentObject)=>{
        var _contentObject_bulletsConfig_bullets, _contentObject_bulletsConfig;
        const modifiedContentObject = _object_spread_props(_object_spread({}, contentObject), {
            buttonConfig: _object_spread_props(_object_spread({}, contentObject.buttonConfig), {
                invert: true,
                buttonSize: "xs",
                withButtonArrow: false
            })
        });
        return /*#__PURE__*/ _jsx("div", {
            className: "tab-content",
            children: /*#__PURE__*/ _jsx(FullWithBulletsParagraphComponent, _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, TAB_CONTENT_DEFAULT_PROPS, modifiedContentObject), {
                bulletsConfig: (contentObject === null || contentObject === void 0 ? void 0 : (_contentObject_bulletsConfig = contentObject.bulletsConfig) === null || _contentObject_bulletsConfig === void 0 ? void 0 : (_contentObject_bulletsConfig_bullets = _contentObject_bulletsConfig.bullets) === null || _contentObject_bulletsConfig_bullets === void 0 ? void 0 : _contentObject_bulletsConfig_bullets.length) ? contentObject.bulletsConfig : null
            }), tabContent), {
                titleSize: XS
            }))
        });
    };
    const testimonialRenderer = ({ testimonial })=>/*#__PURE__*/ _jsx(Testimonial, _object_spread({}, testimonial));
    return /*#__PURE__*/ _jsx(StyledSideBySideTabsAndTestimonialTabsComponent, {
        className: "side-by-side-tabs-and-testimonial-tabs-component",
        children: /*#__PURE__*/ _jsx(VerticalTimerTabs, _object_spread_props(_object_spread({}, rest), {
            prerenderTabs: prerenderTabs,
            title: _object_spread({}, title, advancedTitleConfig),
            tabContentRenderer: contentRenderer,
            rightSideRenderer: testimonialRenderer
        }))
    });
};
SideBySideTabsAndTestimonialTabsComponent.defaultProps = DefaultProps;
export default SideBySideTabsAndTestimonialTabsComponent;
